import { TemplateFieldsDisplayFn } from '../../../models/template.model';
import { Dash, displayFnWrapper, mapAndFormatDynamicValue } from '../utils/dynamic-data-retrievers';
import { concatValuesBy, defaultTxt, formatNumber } from '@miq/utils';
import { ReportRecord } from '../../../models/report.model';

export const displayFnMap: TemplateFieldsDisplayFn = {
  49: {
    displayFn: displayFnWrapper,
  },
  50: {
    displayFn: displayFnWrapper,
  },
  51: {
    displayFn: displayFnWrapper,
  },
  52: {
    displayFn: displayFnWrapper,
  },
  53: {
    displayFn: (record: ReportRecord, _options, arg1, arg2, arg3) => {
      if (Array.isArray(record.data)) {
        const result = record.data.map(element => {
          const floor = mapAndFormatDynamicValue({ ...record, data: element }, arg2);
          const isWholeFloor = mapAndFormatDynamicValue({ ...record, data: element }, arg3);
          return (floor as string).trim() + '/' + (isWholeFloor === 'Yes' ? 'Whole Floor' : 'Part');
        });
        return concatValuesBy(',', ...new Set(result));
      }
      return concatValuesBy(defaultTxt, mapAndFormatDynamicValue(record, arg1), mapAndFormatDynamicValue(record, arg2));
    },
  },
  54: {
    displayFn: displayFnWrapper,
  },
  851: {
    displayFn: (record: ReportRecord, _, spaceSize) => {
      if (Array.isArray(record.data)) {
        const { entity, field, id } = spaceSize;
        let total = 0;
        let totalComposition = [];
        record.data.forEach(avail => {
          const spaceSizeVal = mapAndFormatDynamicValue(
            { ...record, data: avail },
            { dataType: 'id', entity, field, id }
          );
          total = total + Number(spaceSizeVal[0]);
          totalComposition = [...totalComposition, formatNumber(spaceSizeVal[0], undefined, spaceSize.dataFormat)];
        });
        const result =
          formatNumber(total, undefined, spaceSize.dataFormat) + ` SF(${concatValuesBy('+', ...totalComposition)})`;
        return result;
      } else {
        return mapAndFormatDynamicValue(record, spaceSize);
      }
    },
  },
  55: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return Array.isArray(record.data) ? Dash : mapAndFormatDynamicValue(record, arg);
    },
  },
  56: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return Array.isArray(record.data) ? Dash : mapAndFormatDynamicValue(record, arg);
    },
  },
  392: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return Array.isArray(record.data) ? Dash : mapAndFormatDynamicValue(record, arg);
    },
  },
  58: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return Array.isArray(record.data) ? Dash : mapAndFormatDynamicValue(record, arg);
    },
  },
  59: {
    displayFn: (record: ReportRecord, _options, arg) => {
      return Array.isArray(record.data) ? Dash : mapAndFormatDynamicValue(record, arg);
    },
  },
  97: {
    displayFn: displayFnWrapper,
  },
};
